import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {BaseBlackAndWhiteOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-black-and-white-option';
import {useAppSelector} from '@/hooks';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.types';

export function VideoBgBlackAndWhiteOption(): ReactElement<any> | null {
  const currentPageBackground = useAppSelector(getCurrentPageBackground);

  if (!currentPageBackground) {
    return null;
  }

  if (currentPageBackground.details.type !== BackgroundTypeName.VIDEO) {
    return null;
  }

  const videoDetails = currentPageBackground.details;

  const onToggleOption = (): void => {
    const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
    if (!currentPage) {
      return;
    }
    void currentPage.background.updateFromObject({
      details: {
        effects: {
          blackAndWhite: !videoDetails.effects.blackAndWhite,
        },
      },
    });
  };

  return <BaseBlackAndWhiteOption isChecked={videoDetails.effects.blackAndWhite} onToggleOption={onToggleOption} />;
}
